var _style, _rect, _polygon, _polygon2, _defs, _defs2, _defs3, _defs4, _defs5, _defs6, _defs7, _defs8, _defs9, _defs10, _defs11, _defs12, _defs13, _defs14, _defs15, _defs16, _defs17, _defs18, _defs19, _defs20;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEffectiveTechnologiesLogoColor(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\u0421\\u043B\\u043E\\u0439_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 160 245.6",
    style: {
      enableBackground: "new 0 0 160 245.6"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#00AD7C;}\n\t.st1{fill:#FFFFFF;}\n\t.st2{clip-path:url(#SVGID_00000109030581837505913440000004118862600403943568_);fill:#FFFFFF;}\n\t.st3{clip-path:url(#SVGID_00000068655057001175377650000016409628123844263820_);fill:#FFFFFF;}\n\t.st4{clip-path:url(#SVGID_00000067915556402819173600000012666443198563693996_);fill:#FFFFFF;}\n\t.st5{clip-path:url(#SVGID_00000161613558088170762150000014164949514608938642_);fill:#FFFFFF;}\n\t.st6{clip-path:url(#SVGID_00000057837561247874197010000011621762544426212513_);fill:#FFFFFF;}\n\t.st7{clip-path:url(#SVGID_00000002382873568415142150000017775897248796133036_);fill:#FFFFFF;}\n\t.st8{clip-path:url(#SVGID_00000078046431491156259150000009761707589590021264_);fill:#FFFFFF;}\n\t.st9{clip-path:url(#SVGID_00000096752388951145484620000008959398652617700481_);fill:#FFFFFF;}\n\t.st10{clip-path:url(#SVGID_00000044178044438449745820000010971587878759178636_);fill:#FFFFFF;}\n\t.st11{clip-path:url(#SVGID_00000118360154011048540790000013574672478784186013_);fill:#FFFFFF;}\n\t.st12{clip-path:url(#SVGID_00000172418477477147338930000018213836423791878330_);fill:#FFFFFF;}\n\t.st13{clip-path:url(#SVGID_00000062150104224417169620000012905281837503615137_);fill:#FFFFFF;}\n\t.st14{clip-path:url(#SVGID_00000094595244134858184980000010678193778250179503_);fill:#FFFFFF;}\n\t.st15{clip-path:url(#SVGID_00000122706842247099141120000010707075436720408451_);fill:#FFFFFF;}\n\t.st16{clip-path:url(#SVGID_00000105392011242921244850000004138200778197307265_);fill:#FFFFFF;}\n\t.st17{clip-path:url(#SVGID_00000041998964283608392580000007158942188850306207_);fill:#FFFFFF;}\n\t.st18{clip-path:url(#SVGID_00000142898146287296792280000006904142955417862566_);fill:#FFFFFF;}\n\t.st19{clip-path:url(#SVGID_00000160873696177980252940000002890019931850730644_);fill:#FFFFFF;}\n\t.st20{clip-path:url(#SVGID_00000034059835889726269120000010948612968154870967_);fill:#FFFFFF;}\n\t.st21{clip-path:url(#SVGID_00000156568857082595155290000010679970191536384185_);fill:#FFFFFF;}\n")), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "st0",
    width: 32,
    height: 160
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "64,32 64,64 128,64 128,96 64,96 64,128 160,128 160,96 160,64 160,32 "
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "0,213 20.2,213 20.2,206.8 7.1,206.8 7.1,202.1 19.9,202.2 19.9,196 7.1,196 7.1,191.7 20.2,191.7  20.2,185.5 0,185.5 "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_1_",
    width: 160,
    height: 245.6
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000178904263001878741090000005266037889164677260_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000178904263001878741090000005266037889164677260_)",
      fill: "#FFFFFF"
    },
    d: "M25.1,213v-14.4h-3.3 v-5.5h3.3v-1c0-4.2,3-7,7.1-7c2.1,0,4.4,0.6,5.7,2l-2.4,3.6c-0.5-0.5-1.1-0.8-2-0.8c-1.2,0-2.2,0.8-2.2,2.2v1h4.3v5.5h-4.3V213 H25.1z"
  })), /*#__PURE__*/React.createElement("g", null, _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000052083633204937841530000013657484073528653237_",
    width: 160,
    height: 245.6
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000132808264679285924850000016779275585122588837_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000052083633204937841530000013657484073528653237_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000132808264679285924850000016779275585122588837_)",
      fill: "#FFFFFF"
    },
    d: "M39.1,213v-14.4h-3.3 v-5.5h3.3v-1c0-4.2,3-7,7.1-7c2.2,0,4.4,0.6,5.7,2l-2.4,3.6c-0.5-0.5-1.1-0.8-2-0.8c-1.2,0-2.2,0.8-2.2,2.2v1h4v5.5h-4V213H39.1z"
  })), /*#__PURE__*/React.createElement("g", null, _defs3 || (_defs3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000094582951827551441380000002353703965129433497_",
    width: 160,
    height: 245.6
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000182524144813259103590000013537055614836919953_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000094582951827551441380000002353703965129433497_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000182524144813259103590000013537055614836919953_)",
      fill: "#FFFFFF"
    },
    d: "M50.5,203 c0-5.8,4.4-10.4,10.6-10.4c5.9,0,10.2,4.3,10.2,11.1v1.4H57.1c0.4,1.9,2.1,3.6,5,3.6c1.4,0,3.8-0.6,5-1.7l2.7,4 c-2,1.8-5.3,2.6-8.3,2.6C55.2,213.5,50.5,209.5,50.5,203 M61.1,197.5c-2.8,0-3.8,2-4.1,3.4h8.2C65,199.5,64,197.5,61.1,197.5"
  })), /*#__PURE__*/React.createElement("g", null, _defs4 || (_defs4 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000112618338564769761520000010454548008830791583_",
    width: 160,
    height: 245.6
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000145738283195589708460000006136986720972869262_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000112618338564769761520000010454548008830791583_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000145738283195589708460000006136986720972869262_)",
      fill: "#FFFFFF"
    },
    d: "M72.7,203 c0-6.2,4.7-10.4,10.9-10.4c4.3,0,7,1.9,8.2,3.7l-4.1,3.8c-0.8-1.2-2.1-1.9-3.8-1.9c-2.6,0-4.7,1.8-4.7,4.8s2,4.9,4.7,4.9 c1.7,0,3-0.8,3.8-1.9l4.1,3.9c-1.2,1.7-3.9,3.7-8.2,3.7C77.3,213.5,72.7,209.3,72.7,203"
  })), /*#__PURE__*/React.createElement("g", null, _defs5 || (_defs5 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000137104580487029516620000008378028398923983279_",
    width: 160,
    height: 245.6
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000183954506503003685070000014419350721858149037_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000137104580487029516620000008378028398923983279_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000183954506503003685070000014419350721858149037_)",
      fill: "#FFFFFF"
    },
    d: "M95.6,207.7v-9h-3.3 v-5.5h3.3v-5.5h6.3v5.5h4v5.5h-4v7.3c0,1.2,0.7,2,1.8,2c0.7,0,1.4-0.2,1.6-0.5l1.2,4.8c-0.8,0.7-2.4,1.3-4.7,1.3 C97.8,213.6,95.6,211.5,95.6,207.7"
  })), /*#__PURE__*/React.createElement("g", null, _defs6 || (_defs6 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000090979609052485923060000010576001276445510051_",
    width: 160,
    height: 245.6
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000023264789326898288960000004055615938059220651_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000090979609052485923060000010576001276445510051_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000023264789326898288960000004055615938059220651_)",
      fill: "#FFFFFF"
    },
    d: "M108.3,187.7 c0-2,1.6-3.6,3.6-3.6s3.6,1.6,3.6,3.6s-1.6,3.7-3.6,3.7C109.9,191.3,108.3,189.7,108.3,187.7 M108.7,213.1v-19.9h6.4v19.9H108.7z"
  })), /*#__PURE__*/React.createElement("g", null, _defs7 || (_defs7 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000143597225508830460280000000536624938088383640_",
    width: 160,
    height: 245.6
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000042012412665996143250000005237661866592996226_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000143597225508830460280000000536624938088383640_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      clipPath: "url(#SVGID_00000042012412665996143250000005237661866592996226_)",
      fill: "#FFFFFF"
    },
    points: "124.4,213.1  116.6,193.1 123.3,193.1 127.7,205.8 132.3,193.1 139,193.1 131.2,213.1  "
  })), /*#__PURE__*/React.createElement("g", null, _defs8 || (_defs8 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000076605636962988767050000006306662389313540738_",
    width: 160,
    height: 245.6
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000078027733438949154720000002429163246308952241_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000076605636962988767050000006306662389313540738_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000078027733438949154720000002429163246308952241_)",
      fill: "#FFFFFF"
    },
    d: "M139.2,203.1 c0-5.8,4.4-10.4,10.6-10.4c5.9,0,10.2,4.3,10.2,11.1v1.4h-14.2c0.4,1.9,2.1,3.6,5,3.6c1.4,0,3.8-0.6,5-1.7l2.7,4 c-2,1.8-5.3,2.6-8.3,2.6C143.9,213.6,139.2,209.6,139.2,203.1 M149.8,197.6c-2.8,0-3.8,2-4.1,3.4h8.2 C153.8,199.6,152.7,197.6,149.8,197.6"
  })), /*#__PURE__*/React.createElement("g", null, _defs9 || (_defs9 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000132081407554033649740000013660939183646033071_",
    width: 160,
    height: 245.6
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000026851500318646572110000013270169067341623192_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000132081407554033649740000013660939183646033071_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000026851500318646572110000013270169067341623192_)",
      fill: "#FFFFFF"
    },
    d: "M2.3,236.4v-7.3L0,229 v-3.2h2.3V222H6v3.8h2.8v3.2H6v6.3c0,0.9,0.5,1.5,1.3,1.5c0.6,0,1.1-0.2,1.3-0.4l0.8,2.8c-0.6,0.5-1.5,0.9-3.1,0.9 C3.7,240.2,2.3,238.9,2.3,236.4"
  })), /*#__PURE__*/React.createElement("g", null, _defs10 || (_defs10 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000129905449528955202090000006077892529146086274_",
    width: 160,
    height: 245.6
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000065761075338246082280000016176305492411305637_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000129905449528955202090000006077892529146086274_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000065761075338246082280000016176305492411305637_)",
      fill: "#FFFFFF"
    },
    d: "M9.8,232.8 c0-4.1,3-7.4,7.3-7.3c4.2,0,7,3.1,7,7.7v0.8H13.7c0.2,1.8,1.7,3.3,4,3.3c1.2,0,2.8-0.5,3.7-1.4l1.6,2.4c-1.4,1.3-3.6,1.9-5.8,1.9 C13,240.2,9.8,237.3,9.8,232.8 M17.1,228.4c-2.3,0-3.3,1.7-3.5,3.1h6.9C20.4,230.2,19.5,228.4,17.1,228.4"
  })), /*#__PURE__*/React.createElement("g", null, _defs11 || (_defs11 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000031912011622620428180000003253016247027279543_",
    width: 160,
    height: 245.6
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000150063198984466231000000003122742587377534344_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000031912011622620428180000003253016247027279543_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000150063198984466231000000003122742587377534344_)",
      fill: "#FFFFFF"
    },
    d: "M25.1,232.8 c0-4.3,3.1-7.4,7.4-7.3c2.9,0,4.6,1.3,5.5,2.5l-2.4,2.3c-0.7-1-1.7-1.5-3-1.5c-2.2,0-3.8,1.6-3.8,4.1c0,2.4,1.6,4.1,3.8,4.1 c1.3,0,2.3-0.6,3-1.5l2.4,2.2c-0.9,1.3-2.7,2.6-5.5,2.6C28.3,240.2,25.1,237.2,25.1,232.8"
  })), /*#__PURE__*/React.createElement("g", null, _defs12 || (_defs12 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000119838655261685510670000011178335390989072784_",
    width: 160,
    height: 245.6
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000182488993906191377300000008297651053763613338_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000119838655261685510670000011178335390989072784_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000182488993906191377300000008297651053763613338_)",
      fill: "#FFFFFF"
    },
    d: "M49.3,239.9v-8.5 c0-1.9-1-2.6-2.6-2.6c-1.4,0-2.6,0.8-3.2,1.7v9.4h-3.7v-19.4h3.7v7.2c0.9-1.1,2.6-2.2,4.9-2.2c3.1,0,4.6,1.7,4.6,4.4v10 L49.3,239.9z"
  })), /*#__PURE__*/React.createElement("g", null, _defs13 || (_defs13 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000135675915996207273290000013019736248349872807_",
    width: 160,
    height: 245.6
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000103977590682009802510000010730278957177038473_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000135675915996207273290000013019736248349872807_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000103977590682009802510000010730278957177038473_)",
      fill: "#FFFFFF"
    },
    d: "M65.4,239.9v-8.5 c0-1.9-1-2.6-2.6-2.6c-1.5,0-2.6,0.8-3.2,1.7v9.4h-3.7v-14h3.7v1.8c0.9-1.1,2.6-2.2,4.9-2.2c3.1,0,4.6,1.7,4.6,4.5v9.9L65.4,239.9 z"
  })), /*#__PURE__*/React.createElement("g", null, _defs14 || (_defs14 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000036960962771952585850000011115514800654258849_",
    width: 160,
    height: 245.6
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000174575553596707970990000011797104178089527975_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000036960962771952585850000011115514800654258849_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000174575553596707970990000011797104178089527975_)",
      fill: "#FFFFFF"
    },
    d: "M71.1,232.9 c0-4,2.8-7.4,7.4-7.3c4.6,0,7.4,3.4,7.4,7.4s-2.8,7.4-7.4,7.4C73.9,240.2,71.1,236.9,71.1,232.9 M82.2,232.9 c0-2.2-1.3-4.1-3.6-4.1c-2.3,0-3.6,1.9-3.6,4.1c0,2.2,1.3,4.1,3.6,4.1C80.8,237,82.1,235.1,82.2,232.9"
  })), /*#__PURE__*/React.createElement("g", null, _defs15 || (_defs15 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000040538311401300461880000000878288313038667433_",
    width: 160,
    height: 245.6
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000005983310892823406160000003522925133299799985_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000040538311401300461880000000878288313038667433_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 88,
    y: 220.5,
    style: {
      clipPath: "url(#SVGID_00000005983310892823406160000003522925133299799985_)",
      fill: "#FFFFFF"
    },
    width: 3.7,
    height: 19.4
  })), /*#__PURE__*/React.createElement("g", null, _defs16 || (_defs16 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000176024442525705275440000000955727260439536778_",
    width: 160,
    height: 245.6
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000081639009843392502480000013249089280994010529_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000176024442525705275440000000955727260439536778_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000081639009843392502480000013249089280994010529_)",
      fill: "#FFFFFF"
    },
    d: "M93.7,232.9 c0-4,2.8-7.4,7.4-7.3c4.6,0,7.4,3.4,7.4,7.4s-2.8,7.4-7.4,7.4C96.5,240.3,93.7,236.9,93.7,232.9 M104.7,232.9 c0-2.2-1.3-4.1-3.6-4.1c-2.3,0-3.6,1.9-3.6,4.1c0,2.2,1.3,4.1,3.6,4.1C103.4,237,104.7,235.1,104.7,232.9"
  })), /*#__PURE__*/React.createElement("g", null, _defs17 || (_defs17 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000059311372377482779310000000294418689736822695_",
    width: 160,
    height: 245.6
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000139273958052845185900000007915526403806586524_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000059311372377482779310000000294418689736822695_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000139273958052845185900000007915526403806586524_)",
      fill: "#FFFFFF"
    },
    d: "M110.3,243.5l1.7-2.7 c1.1,1.2,2.6,1.7,4.4,1.7s3.9-0.8,3.9-3.5v-1.4c-1.1,1.4-2.6,2.2-4.3,2.2c-3.5,0-6.2-2.5-6.2-7.1s2.7-7.1,6.2-7.1 c1.7,0,3.2,0.7,4.3,2.2V226h3.7v13.1c0,5.3-4.1,6.7-7.6,6.6C113.9,245.6,112,245.1,110.3,243.5 M120.2,234.9v-4.5 c-0.6-0.9-1.9-1.6-3.2-1.6c-2.1,0-3.5,1.5-3.5,3.9s1.5,3.9,3.5,3.9C118.2,236.5,119.6,235.8,120.2,234.9"
  })), /*#__PURE__*/React.createElement("g", null, _defs18 || (_defs18 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000142857999662627755230000015421487134242239910_",
    width: 160,
    height: 245.6
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000047782468414661590700000017242189094138258365_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000142857999662627755230000015421487134242239910_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000047782468414661590700000017242189094138258365_)",
      fill: "#FFFFFF"
    },
    d: "M126.5,222.2 c0-1.2,1-2.2,2.2-2.2s2.2,1,2.2,2.2s-1,2.2-2.2,2.2S126.5,223.4,126.5,222.2 M126.8,239.9v-14h3.7v14H126.8z"
  })), /*#__PURE__*/React.createElement("g", null, _defs19 || (_defs19 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000132787125943461390430000017271417520566364295_",
    width: 160,
    height: 245.6
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000021101269133216208020000014522642405685989535_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000132787125943461390430000017271417520566364295_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000021101269133216208020000014522642405685989535_)",
      fill: "#FFFFFF"
    },
    d: "M132.6,232.9 c0-4.1,3-7.4,7.3-7.3c4.2,0,7,3.1,7,7.7v0.8h-10.4c0.2,1.8,1.7,3.3,4,3.3c1.2,0,2.8-0.5,3.7-1.4l1.6,2.4c-1.4,1.3-3.6,1.9-5.8,1.9 C135.8,240.3,132.6,237.4,132.6,232.9 M139.8,228.5c-2.3,0-3.3,1.7-3.5,3.1h6.9C143.2,230.3,142.3,228.5,139.8,228.5"
  })), /*#__PURE__*/React.createElement("g", null, _defs20 || (_defs20 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000047037165427788930830000016666993943027513022_",
    width: 160,
    height: 245.6
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000000216383468818948250000001892687525911546278_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000047037165427788930830000016666993943027513022_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000000216383468818948250000001892687525911546278_)",
      fill: "#FFFFFF"
    },
    d: "M147.6,238.1l1.6-2.6 c1,1,3.1,1.9,4.9,1.9c1.6,0,2.4-0.6,2.4-1.5c0-2.3-8.3-0.4-8.3-6c0-2.4,2.1-4.4,5.8-4.4c2.4,0,4.3,0.8,5.7,1.9L158,230 c-0.8-0.9-2.4-1.6-4.2-1.6c-1.3,0-2.2,0.6-2.2,1.4c0,2.1,8.3,0.4,8.3,6c0,2.6-2.2,4.5-6.1,4.5 C151.4,240.3,149.1,239.5,147.6,238.1"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEffectiveTechnologiesLogoColor);
export default __webpack_public_path__ + "static/media/Effective Technologies_logo_color.5916666c17adbb99c70a9a2d9a801765.svg";
export { ForwardRef as ReactComponent };